import type { Contracts } from "@/src/gql/graphql";
import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import { CONTRACTS_CONFIG } from "@/features/contracts/components/ContractsConfig";
import { CONTRACT_DETAIL_CONFIG } from "@/features/contracts/components/ContractDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// CONTRACTS ENTITY DEFINITION
// ============================================================================
// Read-mostly entity: contracts are e-signature documents created by the
// contract send flow, not the generic create form (see contracts-graphql.ts).
// Column change: edit features/contracts/components/ContractsConfig.ts.
// Detail page change: edit features/contracts/components/ContractDetailConfig.ts.
// Note: CONTRACT_DETAIL_CONFIG is loosely typed (href launch actions) — cast required.
// ============================================================================

export const contractsEntity = defineEntity<Contracts>({
  tableConfig: CONTRACTS_CONFIG,

  // Untyped detail config — cast to satisfy EntityDefinition contract
  detailConfig: CONTRACT_DETAIL_CONFIG as unknown as DetailPageConfig<Contracts>,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
